export default __webpack_public_path__ + "static/media/LoaderIcon.ad04fe7e.svg";